export { createRoutesDict } from '@cp/common/routing/client/web';
